import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useT } from "@/context/LanguageContext";
import { listJournal } from "@/lib/api";
import { useSEO } from "@/hooks/useSEO";

const Journal = () => {
  const { t } = useT();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useSEO({ title: "Journal · GOYA LISBOA" });

  useEffect(() => {
    listJournal()
      .then((data) => setArticles(data))
      .catch(() => setArticles([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="pt-28 md:pt-36 pb-24 px-6 md:px-12" data-testid="journal-page">
      <div className="font-typewriter text-[10px] tracking-[0.3em] uppercase text-[#6B6862]">{t("journal.eyebrow")}</div>
      <h1 className="font-serif-display text-5xl md:text-7xl mt-3 tracking-tight">{t("journal.title")}</h1>

      {loading ? (
        <div className="mt-16 text-sm text-[#8A7568]">A carregar…</div>
      ) : articles.length === 0 ? (
        <div className="mt-16 max-w-md">
          <p className="text-[#8A7568]">Ainda não há histórias para partilhar — em breve.</p>
        </div>
      ) : (
        <div className="grid md:grid-cols-3 gap-10 mt-16" data-testid="journal-grid">
          {articles.map((a) => (
            <Link
              key={a.id}
              to={`/journal/${a.slug}`}
              className="group block"
              data-testid={`journal-card-${a.slug}`}
            >
              <div className="img-zoom-wrap aspect-[3/4] bg-[#FFFFFF] overflow-hidden">
                {a.image_url ? (
                  <img src={a.image_url} alt={a.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                ) : (
                  <div className="w-full h-full bg-[#F9F1E4] flex items-center justify-center text-[#8A7568] text-xs">Sem imagem</div>
                )}
              </div>
              <h2 className="font-serif-display text-2xl mt-4 leading-tight text-[#241C18]">{a.title}</h2>
              {a.excerpt && (
                <p className="text-sm text-[#6B6862] mt-2 leading-relaxed line-clamp-3">{a.excerpt}</p>
              )}
              <span className="mt-4 link-edit inline-block font-typewriter text-[10px] tracking-[0.24em] uppercase">{t("journal.readOn")}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default Journal;
